import WDHCarousel from './src/js/wdh-carousel';
export { WDHCarousel };